import APIClient from '../../functions/APIClient';
import { AppSettingsConfigType } from '../loader/loadAppsettingsConfig';

const updateAppsettingsConfig = async (updatedConfig: Partial<AppSettingsConfigType>) => {
  return APIClient<AppSettingsConfigType>('/api/appsettings/config/', {
    method: 'POST',
    body: updatedConfig,
  });
};

export default updateAppsettingsConfig;
